export default {
  lang: 'en',
  messages: {
    'app.title': 'Equipment Pools',
    'app.title2': 'Equipment Pools',
    'app.title3': 'Equipment Pools - {context}',
    'app.copyright': '© {copyrightYear} International Post Corporation',
    'app.signIn': 'sign in',
    'app.signOut': 'sign out',
    'app.header.navigation.logout': 'Logout',
    'app.forms.date_picker.label.ok': 'OK',
    'app.forms.date_picker.label.cancel': 'Cancel',
    'app.login.username': 'USERNAME',
    'app.login.password': 'PASSWORD',
    'app.login.login': 'LOGIN',
    'app.login.validations.required': 'Required',
    'app.login.errors.credentials': 'The username and password combination provided is incorrect, please correct and retry.',
    'app.login.message.tokenExpired': 'Your session expired. Please login to continue using the application.',
    'app.table.download': 'Download',
    'app.server.error': 'Unexpected server error',
    'message.notFound': '404: Page not found',
    'button.login': 'Login',
    'filter-component.action.filter': 'Filter',
    'filter-component.action.apply': 'Apply',
    'filter-component.action.clear-filter': 'Clear',
    'filter-component.action.cancel': 'Cancel',
    'filter-component.label.equals': 'Equals',
    'filter-component.label.greater-than': 'Greater than',
    'filter-component.label.greater-than-equal-to': 'Greater than or equal to',
    'filter-component.label.smaller-than': 'Smaller than',
    'filter-component.label.smaller-than-equal-to': 'Smaller than or equal to',
    'filter-component.label.between': 'Between',
    'filter-component.label.contains': 'Contains',
    'filter-component.label.starts-with': 'Starts with',
    'menu.item.transactions.management': ' Transaction management',
    'menu.item.transactions.management.view': ' View Transactions',
    'menu.item.transactions.management.history': ' Transaction history',
    'menu.item.reporting': ' Reports',
    'menu.item.reporting.flux-vol.operator': ' FLUX & VOLUME OPERATOR',
    'menu.item.reporting.flux-vol.impc': ' FLUX & VOLUME OE',
    'menu.item.reporting.boh': ' BALANCE ON HAND',
    'menu.item.reporting.tray.usage': ' 940. IPC TRAY USAGE',
    'menu.item.reporting.tray.mixedUsage': ' 942. MIXED TRAY USAGE',
    'menu.item.reporting.tray.comparativeUsage': ' 941. COMPARATIVE USAGE REPORT FOR TRAYS',
    'menu.item.reporting.bag.usage': ' 950. BAG USAGE',
    'menu.item.reporting.bag.comparativeUsage': ' 951. COMPARATIVE USAGE REPORT FOR BAGS',
    'menu.item.reporting.pallet.usage': ' 960. PALLET-BOX USAGE',
    'menu.item.reporting.pallet.comparativeUsage': ' 961. COMPARATIVE USAGE REPORT FOR PALLET BOXES',
    'menu.item.reporting.total.pool.reporting': ' TOTAL POOL BREAKDOWN',
    'menu.item.reporting.predes.resdes.diff': ' PREDES RESDES ANALYSIS',
    'menu.item.reporting.volume.preadvised': ' DESPATCH PARTICULARS',
    'menu.item.reporting.rfid.movements.counts': ' RFID MOVEMENT COUNTS',
    'menu.item.reporting.rfids.on.route': ' RFIDS ON ROUTES',
    'menu.item.reporting.daily.route.summary': 'Daily route leading count summary',
    'menu.item.stock.management': ' Stock management',
    'menu.item.stock.management.transactions': 'Transactions',
    'menu.item.stock.management.center.repatriations': 'Center initiated repatriations',
    'menu.item.stock.management.internal.repatriations': 'Internal repatriations',
    'menu.item.stock.management.daily.route': 'Daily route leading count Status',
    'menu.item.stock.management.edi-rfid.audit': 'EDI-RFID audit',
    'menu.item.stock.management.misroute.audit': 'Misroute audit',
    'menu.item.stock.management.recalculate.task': 'Recalculate Tasks',
    'menu.item.settings': ' Settings',
    'menu.item.settings.route.management': ' ROUTE MANAGEMENT',
    'menu.item.settings.impc.management': ' IMPC MANAGEMENT',
    'menu.item.settings.user.management': ' USER MANAGEMENT',
    'menu.item.settings.member.pool.storage': ' MEMBER POOL STORAGE',
    'menu.item.settings.rfid': ' RFID file management',
    'menu.item.settings.pool.membership.management': ' Pool Membership Management',
    'notification.impc.edit.success': 'IMPC update successful.',
    'notification.impc.edit.failure': 'IMPC update failed.',
    'notification.route.create.success': 'Route modification transaction successfully created. This data will be displayed in {transactionProcessingFrequency} mins.',
    'notification.route.edit.success': 'Route modification transaction successfully created. This data will be displayed in {transactionProcessingFrequency} mins.',
    'notification.rfidfile.upload.success': 'RFID file uploaded successfully.',
    'notification.rfidfile.download.success': 'RFID file downloaded successfully.',
    'notification.rfidfile.upload.failure': 'RFID file upload failed.',
    'notification.rfidfile.download.failure': 'RFID file download failed.',
    'notification.rfidfile.delete.success': 'RFID file delete successful.',
    'notification.rfidfile.delete.failure': 'RFID file delete failed.',
    'notification.bohthresholds.edit.failure': 'BOH threshold update failed.',
    'notification.bohtransaction.create.success': 'BOH transaction is successfully created',
    'notification.bohtransaction.delete.success': 'BOH transaction is successfully deleted',
    'notification.bohtransaction.delete.fail': 'BOH transaction delete failed',
    'notification.bohtransaction.edit.success': 'BOH transaction is successfully edited. This data will be displayed in {transactionProcessingFrequency} mins.',
    'notification.repatriations.transaction.confirm.success': 'Repatriation transaction successfully confirmed.',
    'notification.repatriations.transaction.edit.success': 'Repatriation transaction successfully edited.',
    'notification.repatriations.transaction.execute.success': 'Repatriation transaction successfully executed.',
    'notification.repatriations.transaction.object.success': 'Repatriation transaction successfully objected.',
    'notification.internalrepatriationstransactions.create.success': 'Internal repatriation transaction create successful.',
    'notification.internalrepatriationstransactions.create.failure': 'Internal repatriation transaction create failed.',
    'notification.manualpreadvicetransactions.create.success': 'Manual pre-advice transaction successfully created.',
    'notification.manualpreadvicetransactions.apply.success': 'Apply action has successfully executed on selected transactions',
    'notification.manualpreadvicetransactions.delete.success': 'Manual pre-advice transaction successfully deleted.',
    'notification.manualpreadvicetransactions.edit.success': 'Manual pre-advice transaction successfully edited.',
    'notification.member-pool-storage.edit.success': 'Member Pool Storage transaction successfully created. This data will be displayed in {transactionProcessingFrequency} mins.',
    'notification.predes.transactions.reject.success': 'PREDES transaction successfully rejected',
    'notification.predes.transactions.bulk-reject.success': 'PREDES transactions successfully rejected',
    'notification.predes.transactions.release.success': 'PREDES transaction successfully released',
    'notification.predes.transactions.bulkrelease.success': 'PREDES transactions successfully released',
    'notification.predes.transaction.object.success': 'Predes transaction successfully objected.',
    'notification.predes.edit.success': 'Predes transaction successfully edited.',
    'notification.edirfidaudit.delete.success': 'EDI-RFID audit request delete successful.',
    'notification.edirfidaudit.delete.failure': 'EDI-RFID audit request delete failed.',
    'notification.edirfidauditrequest.create.success': 'EDI-RFID audit request create successful.',
    'notification.edirfidauditrequest.create.failure': 'EDI-RFID audit request create failed.',
    'notification.edirfidauditexecution.delete.success': 'EDI-RFID audit execution(s) deleted.',
    'notification.edirfidauditexecution.delete.failure': 'EDI-RFID audit execution(s) can not be deleted.',
    'notification.centerinitiatedrepatriationstransactions.create.success': 'A Center Initiated Repatriation transaction has been created.',
    'notification.centerinitiatedrepatriationstransactions.create.failure': 'Center Initiated Repatriation creation failed.',
    'notification.centerinitiatedrepatriationstransactions.delete.success': 'Repatriation transaction has been deleted.',
    'notification.centerinitiatedrepatriationstransactions.delete.failure': 'Repatriation transaction deletion failed.',
    'notification.threshold.modification.transaction.create.success': 'Threshold modification transaction successfully created. This data will be displayed in {transactionProcessingFrequency} mins.',
    'notification.pool.management.update.success': 'Global asset preset is successfully updated',
    'notification.daily-route-leading.use.edi.success': 'USE EDI action successfully executed',
    'notification.daily-route-leading.use.edi.failure': 'USE EDI action execution failed',
    'notification.daily-route-leading.use.max.success': 'USE MAX action successfully executed',
    'notification.daily-route-leading.use.max.failure': 'USE MAX action execution failed',
    'constraints.ediRfidAuditRequest.auditNameShouldBeUnique': 'EDI-RFID audit request create failed. Audit name should be unique.',
    'constraints.ediRfidAuditRequest.startDateShouldBeAfterThanNow': 'Scheduling start date can not be in past',
    'constraints.route.routeAlreadyExists': 'Duplicate route exists',
    'constraints.route.routeAlreadyExistsInOppositeDirection': 'Duplicate route exists in the opposite direction',
    'notification.recalculate-task.create.success': 'Recalculate Task is successfully created',
  },
};
